/* PS. collection page. v9.8 dropdown filters (moved out of main-collection.liquid in v11.1) plus the v11.1 type chips. */
(function () {
  'use strict';
  function go(url) { var u = new URL(url, window.location.origin); u.searchParams.delete('page'); window.location.href = u.toString(); }
  document.querySelectorAll('.ps-plp').forEach(function (root) {
    root.querySelectorAll('[data-fsel-go]').forEach(function (sel) {
      sel.addEventListener('change', function () { go(sel.value); });
    });
    root.querySelectorAll('[data-fsel-param]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var u = new URL(window.location.href);
        var p = sel.getAttribute('data-fsel-param');
        u.searchParams.delete(p);
        if (sel.value !== '') u.searchParams.append(p, sel.value);
        go(u.toString());
      });
    });
    root.querySelectorAll('[data-fsel-price]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var u = new URL(window.location.href);
        var lo = sel.getAttribute('data-min-param'), hi = sel.getAttribute('data-max-param');
        var parts = sel.value.split('|');
        u.searchParams.delete(lo); u.searchParams.delete(hi);
        if (parts[0]) u.searchParams.set(lo, parts[0]);
        if (parts[1]) u.searchParams.set(hi, parts[1]);
        go(u.toString());
      });
    });
    /* Keep the active type chip in view when the row scrolls on phones. */
    var row = root.querySelector('.ps-typechips__row');
    var on = row && row.querySelector('.ps-typechip.is-active');
    if (on && row.scrollWidth > row.clientWidth) row.scrollLeft = Math.max(0, on.offsetLeft - 16);
  });
})();